module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nl/name/suffix.js
// module id = 1524
// module chunks = 0